module.exports = __webpack_public_path__ + "static/img/10.f1f48b4d.png";